const PROMOTER_VIEW =
  'https://sim.simulator.company/script/b4200a67-1df3-4274-96f3-e1127a348348/view_public/portmall-pages/production/client-checks-preprint';

/**
 * Перенаправляет пользователя на страницу промоутера
 * @param {string|number} initiator_id - ID инициатора
 * @param {string|number} contact_id - ID контакта
 * @param {string|number} staff_chat_id - ID чата персонала
 */
export function redirectToPromoterView(
  initiator_id,
  contact_id,
  staff_chat_id,
) {
  const params = new URLSearchParams({
    contact_id: contact_id,
    initiator_id: initiator_id,
    staff_chat_id: staff_chat_id,
  }).toString();
  window.location.replace(`${PROMOTER_VIEW}?${params}`);
}
